import { Controller } from "@hotwired/stimulus"

export default class WtAttemptController extends Controller {
    static targets = [ 'form' ];

    groupChange(): void {
        let textbox = event.currentTarget;
        if (textbox.value.length >= textbox.getAttribute('maxlength')) {
            const index = Array.prototype.indexOf.call(this.formTarget.elements, textbox);
            const next = this.formTarget.elements[index + 1];

            if (next) {
                next.focus();
            }
        }
    }
}